import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

const SectionPlayContainer = styled.svg`
  cursor: pointer;
`;

const SectionPlay = ({width, height, color}) => {
    return (
        <SectionPlayContainer
            version="1.1"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width={width}
            height={height}
            //   viewBox="0 0 238.667 200"
            //   enable-background="new 0 0 238.667 200"
            viewBox="0 0 238.667 200"
            enable-background="new 0 0 238.667 200"
            xmlSpace="preserve"
        >
            <g>
                <g>
                    <path
                        fill={color}
                        d="M6.491,197.278c-1.9,0-3.02-0.137-3.356-0.406c-0.34-0.273-0.508-1.357-0.508-3.254V6.541
			c0-1.896,0.167-3.016,0.508-3.355c0.336-0.337,1.456-0.508,3.356-0.508h27.655c2.034,0,3.219,0.136,3.558,0.406
			c0.336,0.273,0.508,1.356,0.508,3.254V8.98c0,2.034-0.172,3.223-0.508,3.559c-0.339,0.34-1.595,0.509-3.762,0.509H19.302
			c-1.494,0-2.375,0.137-2.645,0.407c-0.272,0.273-0.405,1.22-0.405,2.847v167.556c0,1.49,0.103,2.372,0.304,2.646
			c0.204,0.269,1.049,0.406,2.542,0.406h14.844c2.167,0,3.422,0.167,3.762,0.507c0.336,0.339,0.508,1.525,0.508,3.559v2.44
			c0,1.896-0.172,3.016-0.508,3.355c-0.339,0.337-1.595,0.508-3.762,0.508H6.491z"
                    />
                </g>
                <g>
                    <path
                        fill={color}
                        d="M232.176,2.723c1.9,0,3.02,0.137,3.355,0.406c0.342,0.273,0.508,1.357,0.508,3.254v187.078
			c0,1.896-0.166,3.016-0.508,3.354c-0.336,0.337-1.455,0.507-3.355,0.507h-27.654c-2.035,0-3.219-0.135-3.559-0.405
			c-0.336-0.273-0.508-1.356-0.508-3.254v-2.643c0-2.034,0.172-3.223,0.508-3.56c0.34-0.339,1.596-0.508,3.762-0.508h14.641
			c1.494,0,2.375-0.137,2.645-0.406c0.273-0.273,0.406-1.221,0.406-2.848V16.143c0-1.49-0.104-2.371-0.305-2.645
			c-0.203-0.27-1.049-0.406-2.543-0.406h-14.844c-2.166,0-3.422-0.168-3.762-0.508c-0.336-0.338-0.508-1.525-0.508-3.559V6.586
			c0-1.896,0.172-3.017,0.508-3.355c0.34-0.338,1.596-0.508,3.762-0.508H232.176z"
                    />
                </g>
                <path
                    fill={color}
                    d="M89.452,154.663c-1.132,0-2.262-0.292-3.277-0.879c-2.028-1.171-3.277-3.335-3.277-5.677V53.5
		c0-2.344,1.249-4.506,3.277-5.678c1.014-0.586,2.145-0.879,3.277-0.879c1.132,0,2.263,0.293,3.278,0.879l81.935,47.305
		c2.029,1.171,3.277,3.334,3.277,5.677c0,2.34-1.248,4.508-3.277,5.675l-81.935,47.306
		C91.716,154.371,90.584,154.663,89.452,154.663z"
                />
            </g>
        </SectionPlayContainer>
    );
};

SectionPlay.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    color: PropTypes.string,
};

export default SectionPlay;
